import styled from 'styled-components';

export const Container = styled.div`
  .list-tools {
    position: sticky;
    background: ${(props) => props.theme.$bg_gray};
    top: 3.8em;

    @media (max-width: 992px) {
      top: 3em;
    }
  }

  .itemToolsSelected {
    position: absolute;
    bottom: 2px;
    font-size: 0.9em;

    button {
      font-size: 1em;
    }
  }
`;
